// assets/src/js/modules/sliders.js
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default function initSliders() {
  // Kitchen spaces carousel
  const caroBlocksElement = document.querySelector(".carousel_blocks_caro");
  if (caroBlocksElement) {
    const carousel_blocks_caro = new Swiper(".carousel_blocks_caro", {
      loop: false,
      spaceBetween: 24,
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".caro_block_nav_next",
        prevEl: ".caro_block_nav_prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
        },
        1024: {
          slidesPerView: 4.4,
        },
      },
    });
  }

  const specialProdsElement = document.querySelector(
    ".special_products_wrapper"
  );
  if (specialProdsElement) {
    const special_products_wrapper = new Swiper(".special_products_wrapper", {
      loop: false,
      spaceBetween: 24,
      slidesPerView: 1.2,
      navigation: {
        nextEl: ".special_prods-next",
        prevEl: ".special_prods-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.4,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  // Run on initial load
  // initEventsSwiper();

  // Handle window resize
  window.addEventListener("resize", function () {
    // initEventsSwiper();
  });
}
